<template>
    <v-card flat class="sub-site-wrapper">
        <div v-if="whatsAppConnectionsStats" class="table-statistics-wrapper">
            <v-row>
                <v-col cols="12" sm="3">
                    <div v-if="whatsAppConnectionsStats" class="statistics-text-box elevation-3">
                        <h5>Gesamtzahl der Verbindungen:</h5>
                        <h3>{{ whatsAppConnectionsStats[0].totalConnections }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="whatsAppConnectionsStats" class="statistics-text-box elevation-3">
                        <h5>Agenturen mit mindestens einer Verbindung:</h5>
                        <h3>{{ whatsAppConnectionsStats[0].agenciesWithAtLeastOneConnection }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="whatsAppConnectionsStats" class="statistics-text-box elevation-3">
                        <h5>Durchschnittliche Anzahl der Verbindungen pro Agentur:</h5>
                        <h3>{{ whatsAppConnectionsStats[0].averageConnectionsPerAgency }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="whatsAppConnectionsStats" class="statistics-text-box elevation-3">
                        <h5>Median der Verbindungen pro Agentur:</h5>
                        <h3>{{ whatsAppConnectionsStats[0].medianConnectionsPerAgency }}</h3>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="3">
                    <div v-if="whatsAppConnectionsStats" class="statistics-text-box elevation-3">
                        <h5>Anzahl der erstellten Verbindungen in den letzten 24 Stunden:</h5>
                        <h3>{{ whatsAppConnectionsStats[0].connectionsLast24Hours }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="whatsAppConnectionsStats" class="statistics-text-box elevation-3">
                        <h5>Anzahl der erstellten Verbindungen in den letzten 7 Tagen:</h5>
                        <h3>{{ whatsAppConnectionsStats[0].connectionsLast7Days }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="whatsAppConnectionsStats" class="statistics-text-box elevation-3">
                        <h5>Anzahl der erstellten Verbindungen in den letzten 30 Tagen:</h5>
                        <h3>{{ whatsAppConnectionsStats[0].connectionsLast30Days }}</h3>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div class="statistics-text-box elevation-3">
                        <h5>Informationen zu den Statistiken:</h5>
                        <p>Es fließen nur Agenturen in die Statistik ein, die eine Stripe Subscription ID besitzen und
                            mindestens einen Slot haben.</p>
                        <p>Die Statistiken wurden am <b>{{ statisticsAge }}</b> erstellt.</p>
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>

<script>

import { mapState, mapActions } from 'vuex';

export default {
    components: {

    },
    created() {
        this.loadStatistics();
    },
    computed: {
        ...mapState('statistics', ['whatsAppConnectionsStats', 'loading', 'statisticsAge'])
    },
    methods: {
        ...mapActions('statistics', ['fetchMostRecentStatistic']),
        async loadStatistics() {
            await this.fetchMostRecentStatistic();
        },
    },
}

</script>

<style lang="scss" scoped>
.table-statistics-wrapper {
    padding: 24px;
}


.statistics-text-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    font-weight: 500;
    border: 1px solid rgb(196, 196, 196);
    border-radius: 12px;
    padding: 12px;
}
</style>